<template>
    <rkm-overlay>
        <rkm-layout-body title="Marcador de Consumo Alimentar - Histórico">

            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
                <rkm-button
                    @click="create()"
                    color="primary"
                >
                    Novo Atendimento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Historico :id="id" @paciente="handlePaciente" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Enums.
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Components
import Historico from '@/components/atencao-basica/marcador-consumo-alimentar/components/historico/List';

// Vuex
import { mapActions } from 'vuex';

// Mixins.
import { repository, error, stringCase } from '@/mixins'

export default {
    components: { Historico },
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        paciente: null,
        enums: {
            subclassificacao
        }
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
            'setLoading',
            'unsetLoading'
        ]),
        redirectToList() {
            this.$router.push({
                name: 'atencao-basica-marcador-consumo-alimentar-index'
            });
        },
        handleExit() {
            this.showExitConfirmation(async() => {
                this.unsetShowExitFormConfirmation();
                this.redirectToList();
            });
        },
        create() {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: this.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (this.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                            const confirm = async () => {

                                this.$router.push({ name: 'atencao-basica-marcador-consumo-alimentar-create', params: { id: this.id } })

                                return false
                            }

                            const msg = `Paciente com cadastro temporário. Deseja continuar?`

                            this.showConfirmation(msg, confirm)

                            return false
                    }

                    this.$router.push({ name: 'atencao-basica-marcador-consumo-alimentar-create', params: { id: this.id } })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePaciente(paciente) {

            this.paciente = paciente
        },
    },
    mixins: [ repository, error, stringCase ],
    props: {
        id: { type: Number, default: null }
    }
}
</script>